/* eslint-disable react/prop-types */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Carousel as CarouselBase, Picture as PictureBase, VideoPlayer as VideoPlayerBase } from 'assets/lib'
import { withPortalThemeLegacy } from 'modules/utils';
import AtomicBlockWrapper from './RichTextEditorAtomicBlockWrapper'

// this components need the portal styled components theme
const Picture = (props) => withPortalThemeLegacy(PictureBase, props)
const Carousel = (props) => withPortalThemeLegacy(CarouselBase, props)
const VideoPlayer = (props) => withPortalThemeLegacy(VideoPlayerBase, props)

const renderCarousel = (imagesMarkdown) => {
  const imageRegex = /(^!\[([^\]]*)]\s*\(([^)"]+)( "([^"]+)")?\))/gm
  const picturesMatches = [...imagesMarkdown.matchAll(imageRegex)]
  const pictures = picturesMatches.map(match => {
    const alt = match[2]
    const src = match[3]
    const title = match[5]
    return {
      alt, src, title
    }
  })
  return pictures.map(
    ({ src, alt, title }) => <Picture key={alt} src={src} alt={alt} title={title} />
  )
}

const AtomicBlock = ({ block, contentState }) => {
  // get block entity data

  // HACK: removed the useMemo from entity because when editing a block entity
  // the replaceEntityData doesnt really "change" the editorState
  // so the useMemo wouldnt trigger
  // https://github.com/facebook/draft-js/issues/1702
  const entity = contentState.getEntity(block.getEntityAt(0));
  const data = useMemo(() => entity.getData(), [entity]);
  const type = useMemo(() => entity.getType(), [entity]);

  // render appropriate component based on atomic block entity type
  let atomicBlockComponent = <div>Invalid AtomicBlock type</div>;
  switch (type) {
  case 'VIDEO':
    atomicBlockComponent = (
      <div className="video-block">
        <VideoPlayer url={data.url} />
      </div>
    )
    break;
  case 'CAROUSEL':
    atomicBlockComponent = (<Carousel>{renderCarousel(data)}</Carousel>);
    break;
  case 'IMAGE':
    atomicBlockComponent = (<Picture {...data} isLocal={false} />);
    break;
  default:
    atomicBlockComponent = <div>Invalid AtomicBlock type</div>
  }
  return (
    <AtomicBlockWrapper contentState={contentState} block={block}>
      {atomicBlockComponent}
    </AtomicBlockWrapper>
  )
}

AtomicBlock.propTypes = {
  block: PropTypes.shape({}).isRequired,
  contentState: PropTypes.shape({}).isRequired,
}

export default AtomicBlock
